export default "__VITE_PUBLIC_ASSET__86359c8d__"